module.exports = __webpack_public_path__ + "img/078.3fd660ba.png";